export enum InternalCommunicationType {
  CarrierStatusAlert = 1,
  InternalGenericEmailWithoutTemplate = 2,
  InternalGenericEmailWithTemplate = 3,
  MissingRecipe = 4,
  CustomerRecipeOk = 5,
  FirstCustomerRecipeAndActivation = 6,
  FirstCustomerRecipeWithLogin = 7,
  UpdateCustomerRecipeWithLogin = 8,
  CustomerRecipeUsed = 9,
  CustomerRecipeSavedUsed = 10,
  CustomerRecipeAddedWithLinking = 11,
  CustomerRecipeLinkedAndNotConfirmed = 12,
  CustomerRecipeAddedWithoutLinking = 13,
  CustomerRecipeOnlyAdded = 14,
  LensesInProduction = 15,
  OrderDispatched = 16,
  OrderDispatchedPos = 17,
  OrderDelivered = 18,
  DelayedOrder = 19,
  PaidOrder = 20,
  OrderInvoiced = 21,
  Cashback = 22,
  CashbackReminder = 23,
  PaidOrderWithLenses = 24,
  OrderInvoicedWithLenses = 25,
  OrderDeliveredWithLenses = 26,
  OrderDispatchedWithLenses = 27,
  PhysicalStoreOrderDeadline = 28,
  MissingRecipeV2 = 29,
  MissingRecipeReminderV2 = 30,
  CustomerRecipeSavedUsedV2 = 31
}